import React from 'react';
import { Button, InputBaseComponentProps, Stack } from '@mui/material';
import { mdiAccountCircle } from '@mdi/js';
import UserAvatar from '../UserAvatar';
import { vars } from '../../../../Theme';
import { TFunction } from 'react-i18next';

/** Object that provides data for user settings Dialog. */
export const settingsDataObject = ({
    username,
    first_name,
    last_name,
    email,
    pictureLoading,
    handleChangeImage,
    t,
}: ISettingsDataAttributes): ISettingsDataObject => ({
    profile: {
        name: 'profile',
        icon: mdiAccountCircle,
        data: [
            {
                label: 'userName',
                value: username,
                children: () => (
                    <Stack direction='row' spacing={0.5} sx={{ ml: '1rem', alignItems: 'center' }}>
                        <UserAvatar size={50} loading={pictureLoading} />
                        <Button
                            component='label'
                            variant='outlined'
                            sx={{
                                textTransform: 'capitalize',
                                backgroundColor: vars.fillGray,
                                color: vars.font,
                                borderColor: vars.font,
                                height: '32px',
                            }}
                        >
                            {t('chooseImage')}
                            <input
                                hidden
                                accept='image/jpg, image/jpeg, image/png'
                                type='file'
                                onChange={handleChangeImage}
                            />
                        </Button>
                    </Stack>
                ),
            },
            {
                label: 'firstName',
                value: first_name,
            },
            {
                label: 'lastName',
                value: last_name,
            },
            {
                label: 'account',
                value: email,
            },
        ],
    },
});

/**
 * Interface that describes Settings Dialog Tab's Data.
 */
export interface ISettingsDialogTabData {
    label: string;
    value: string;
    viewItemComponentProps?: {
        align?: string;
        multiline?: boolean;
        inputProps?: InputBaseComponentProps;
    };

    children?: () => JSX.Element;
}

/**
 * Interface that describes Setting's Dialog Tab.
 */
interface ISettingsDialogTab {
    name: string;
    icon: string;
    data: ISettingsDialogTabData[];
}

/**
 * Interface that describes Setting's Dialog Data Object.
 */
export interface ISettingsDataObject {
    profile: ISettingsDialogTab;
}

/**
 * Interface that describes Setting's Dialog Data Attributes.
 */
export interface ISettingsDataAttributes {
    username: string;
    first_name: string;
    last_name: string;
    email: string;
    pictureLoading: boolean;
    handleChangeImage: (e: React.ChangeEvent<HTMLInputElement>) => void;
    t: TFunction<'header', undefined>;
}
